import * as THREE from "three";

export default class Planet {
  parent;
  planet;
  circle;
  moons = [];
  yearLength;
  dayLength;
  distance;

  circleVisible = true;
  constructor(
    scene,
    distance,
    size,
    color,
    yearLength,
    daylength,
    options = {}
  ) {
    this.yearLength = yearLength;
    this.dayLength = daylength;
    this.distance = distance;
    if (!options.rotation) options.rotation = new THREE.Vector3(0, 0, 0);

    this.parent = new THREE.Group();
    scene.add(this.parent);

    const geometry = new THREE.SphereGeometry(size);
    const material = new THREE.MeshStandardMaterial({
      color,
      map: options.colorMap || null,
    });
    this.planet = new THREE.Mesh(geometry, material);
    this.planet.position.z = distance;
    this.planet.receiveShadow = true;
    this.planet.castShadow = true;
    this.parent.rotation.set(
      options.rotation.x,
      options.rotation.y,
      options.rotation.z
    );
    this.parent.add(this.planet);

    const circleMat = new THREE.MeshStandardMaterial(0xffffff);
    const circleGeometry = new THREE.RingGeometry(
      distance,
      distance,
      15 * distance
    );
    circleGeometry.rotateX(Math.PI * 0.5);
    const circleLineLoop = new THREE.LineLoop(circleGeometry, circleMat);
    this.parent.add(circleLineLoop);
    this.circle = circleLineLoop;
  }

  addMoon(size, distance) {
    const moonParent = new THREE.Group();
    moonParent.position.set(
      this.planet.position.x,
      this.planet.position.y,
      this.planet.position.z
    );
    this.parent.add(moonParent);
    const moon = new Planet(
      moonParent,
      distance,
      size,
      0xffffff,
      30,
      undefined
    );
    const hello = new THREE.Vector3();
    moon.planet.getWorldPosition(hello);
    console.log(hello);
    this.moons.push(moon);
  }

  rotate(speed) {
    this.parent.rotateY((Math.PI * 2 * speed) / this.yearLength);
    if (this.dayLength)
      this.planet.rotateY((Math.PI * 2 * speed) / this.dayLength / 50);
    this.moons.forEach((moon) => {
      moon.rotate(speed);
    });
  }

  toggleCircle = () => {
    console.log("Toogle Circle");
    this.circle.visible = !this.circleVisible;
    this.circleVisible = !this.circleVisible;
    this.moons.forEach((moon) => moon.toggleCircle());
    console.log(this.moons);
  };
}
